import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function ViewerOverlay({ visible, closeAllPanels }) {
  return (
    <div
      role="presentation"
      className={classnames('viewer-overlay', { 'viewer-overlay-visible': visible })}
      onClick={() => closeAllPanels()}
    />
  );
}

ViewerOverlay.propTypes = {
  visible: PropTypes.bool,
  closeAllPanels: PropTypes.func,
};

ViewerOverlay.defaultProps = {
  visible: false,
  closeAllPanels: () => {},
};
